import React from "react";
import SectionWrapper from "../components/SectionWrapper";

const PartnersPage = () => {
  return (
    <main
      id="founder-story"
      className="mt-16 bg-gradient-to-b from-cream to-white text-gray-800 leading-relaxed"
      role="main"
      aria-labelledby="founder-story-heading"
    >
      <SectionWrapper className="">
        {/* Header */}
        <header className="text-center mb-10 pt-16">
          <h1
            id="founder-story-heading"
            className="text-3xl md:text-4xl font-bold text-maroon mb-4 pt-16"
          >
            Founder Story —{" "}
            <span className="text-gray-900">Dr. Aman Khera</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-700">
            Founder & Director, <strong>AegisCare Pvt. Ltd.</strong>
          </p>
          <p className="italic text-maroon mt-2">
            “Healthcare solutions for the elderly in India”
          </p>
        </header>

        <div className="flex flex-col lg:flex-row items-center justify-center w-full gap-10 my-10 px-4 lg:px-16">
          {/* ===== Image Section ===== */}
          <div className="flex justify-center lg:w-1/2 w-full">
            <div className="relative group">
              {/* Founder Image */}
              <img
                src="/ImageAndVideo/image/founder.jpg"
                alt="Portrait of Dr. Aman Khera, Founder and Director of AegisCare Pvt. Ltd."
                loading="lazy"
                className="relative z-10 w-full max-w-[350px] sm:max-w-[400px] md:max-w-[450px] lg:max-w-[500px] 
                   h-[500px] object-cover rounded-3xl 
                   transform transition duration-500 ease-in-out hover:scale-105 hover:shadow-2xl"
              />

              {/* Caption */}
              <div className="text-center mt-4">
                <h1 className="text-2xl font-semibold text-maroon">
                  Dr. Aman Khera
                </h1>
                <p className="text-gray-600 text-sm">
                  Founder & Director, AegisCare Pvt. Ltd.
                </p>
              </div>
            </div>
          </div>

          {/* ===== Story Section ===== */}
          <article
            className=" w-full text-justify text-gray-800 leading-relaxed"
            aria-label="Founder story content"
          >
            <p className="mb-5">
              AegisCare is founded by <strong>Dr. Aman Khera</strong>, a
              third-generation doctor with over{" "}
              <strong>25 years of experience</strong> in the healthcare
              industry. Coming from a deeply rooted medical family, Dr. Khera
              has always been passionate about improving healthcare delivery
              systems — not just treating patients, but transforming the way
              care is planned, coordinated, and delivered.
            </p>

            <p className="mb-5">
              Over the years of working in hospitals and healthcare
              institutions, he witnessed a recurring and painful pattern —
              elderly patients navigating the healthcare system alone. He often
              saw senior citizens standing in long queues, moving from one
              counter to another, struggling with forms and procedures, often
              with no one to assist them. Many even avoided visiting hospitals
              altogether out of fear of this exhausting process. Their isolation
              and helplessness left a deep mark on him.
            </p>

            <p className="mb-5">
              At the same time, Dr. Khera interacted with countless families
              living abroad whose parents remained alone in India. Their
              constant worry was evident —{" "}
              <em>
                Are my parents taking their medicines? Are they getting their
                blood tests done? What if an emergency happens while I’m away?
              </em>
              He recalls a personal experience with his friend in the U.S., a
              doctor himself, who was perpetually anxious about his 85-year-old
              father’s cardiac and kidney issues in India. Dr. Khera often
              stepped in personally to help — a gesture that later became the
              seed of a much larger idea.
            </p>

            <p className="mb-5">
              Moved by these experiences, he envisioned{" "}
              <strong>AegisCare</strong> — a comprehensive, technology-enabled
              eldercare ecosystem that ensures no parent in India ever feels
              alone in their healthcare journey. By combining preventive care,
              compassionate coordination, and smart technology, AegisCare
              bridges the gap between elderly parents in India and their
              children abroad, bringing peace of mind and dignity to both
              generations.
            </p>

            <p className="mb-5">
              In a culture that reveres its elders, AegisCare is Dr. Khera’s
              mission to restore trust, convenience, and compassion in eldercare
              — ensuring that every parent receives the kind of care their
              children would give, as though they had never left.
            </p>
          </article>
        </div>
      </SectionWrapper>
    </main>
  );
};

export default PartnersPage;
